/* eslint-disable no-irregular-whitespace */
import request from '@/utils/request'
let preBase = 'mixApi'

// 厦门国际银行维稳礼项目-领奖记录分页查询
export const getRecordPages = (data) => {
  return request({
    url: `${preBase}/xibMaintainRecordDetails/getRecordPages`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data,
    custom: true,
  })
}

// 厦门国际银行维稳礼项目-查询档位
export const queryLevel = (data) => {
  return request({
    url: `${preBase}/xibMaintainRecordDetails/queryLevel`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data,
    custom: true,
  })
}

// 厦门国际银行维稳礼项目-领取奖品
export const receive = (data) => {
  return request({
    url: `${preBase}/xibMaintainRecordDetails/receive`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data,
    custom: true,
  })
}

// 厦门国际银行维稳礼项目-实物领取详情
export const getDetailsById = (data) => {
  return request({
    url: `${preBase}/xibMaintainRecordDetails/getDetailsById`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data,
    custom: true,
  })
}
